/* src/app/shared/components/flow-accordion-container/flow-accordion-container.component.scss */
.accordion-container {
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: fit-content;
  border: 1px solid #d4d4d8;
  border-radius: 12px;
  background-color: #ffffff;
  width: 100%;
}
/*# sourceMappingURL=flow-accordion-container.component.css.map */
